import React from 'react';
import {Link} from "react-router-dom";
import error from '../assets/img/cmu-404.png'


const Error404 = () => {
    return (
        <div style={outerContainerStyles}>
        <div style={containerstyles}>
            <div className="error_404_div">
                <img  src={error} alt="404"/>
                <p style={paragraphStyles} className="error-paragraph">Nothing to see here... just eerie emptiness. Maybe try heading back home?</p>
                <Link to="/" className={'btn-brand'} style={{display: 'inline-Block', marginTop: 30, bordeRadius: '100px', color: '$white', background: '#FFFFFF1A'}}>Go Back
                    Home</Link>
            </div>
        </div>
        </div>
    );
};

const outerContainerStyles = {
    backgroundColor: '#0e0e0e',
    height: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
};

const containerstyles = {
    maxWidth: 1200,
    textAlign: 'center',
    padding: '40px',
};

const paragraphStyles = {
    marginTop: '20px',
};

export default Error404;